<template>
  <div class="row">

    <!-- Confirm to update as a calling a method catching the event and calling api -->
    <change-offer-modal v-if="readyToShow"
                        @cancel="readyToShow = false"
                        @confirm="confirmModal($event)"
                        :newoffer="getnewoffer"
                        :active_cart="getOffersIdFromActiveCart">
    </change-offer-modal>
    <div class="col-md-12">
      <div class="panel panel-default consumptions-list">

        <div class="panel-heading separator">
          <h3>Catalogue</h3>
        </div>

        <div v-if="anyError" class="panel-heading separator">
            <error-notification :error="formError"></error-notification>
        </div>

        <div class="panel-body">
          <catalog-tabs>
            <catalog-tab title="Domiciliation"
                         :is-active="true"
                         @show-modal="readyToShow = !readyToShow">
              <catalog-dom :catalog="catalog_dom"
                           @add="addToCart"
                           :mayupdate="getOffersIdFromActiveCart"
                           @crushcart="cartCrusher">
              </catalog-dom>
            </catalog-tab>

            <catalog-tab title="Locations Longues Durée"
                         @show-modal="readyToShow = !readyToShow">
              <catalog-lld :catalog="catalog_lld"
                           @add="addToCart"
                           :mayupdate="getOffersIdFromActiveCart"
                           @crushcart="cartCrusher">
              </catalog-lld>
            </catalog-tab>

            <!-- <catalog-tab title="Réservations ponctuels" >
                                <catalog-rp :catalog="catalog_pon" @add="addToCart" :mayupdate="getOffersIdFromActiveCart" @crushcart="cartCrusher">
                                </catalog-rp>
                            </catalog-tab> -->

            <!-- <catalog-tab title="Achats immédiats"
                         @show-modal="readyToShow = !readyToShow">
              <catalog-instant-buy v-if="agencies"
                                   :agency="agencies"
                                   :catalog="catalog_inb"
                                   @add="addToCart"
                                   @agencyup="updateFilters({agencies: [$event]})"
                                   :mayupdate="getOffersIdFromActiveCart"
                                   :render="readySelectToRender"
                                   @updatequantity="updateSubquantity"
                                   @crushcart="cartCrusher"
                                   :user_agency="parseInt(current_user_agency[0])">
              </catalog-instant-buy>
            </catalog-tab> -->

            <catalog-tab title="Panier">
              <!-- Activecart as computed -->
              <carts :active="getmyactiveCart"
                     @cleancart="cleanActiveCart($event)"
                     @deletesuborder="delSuborderOfCart($event)"
                     @refresh="fetchActiveCart">
              </carts>
            </catalog-tab>
          </catalog-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapActions, mapGetters, mapState } from 'vuex'

  import ErrorNotification from '../components/Catalog/ErrorNotification'

  import CatalogTabs from '../components/Catalog/CatalogTabs'
  import CatalogTab from '../components/Catalog/CatalogTab'
  import CatalogDom from '../components/Catalog/CatalogDom'
  import CatalogLld from '../components/Catalog/CatalogLld'
  // import CatalogRp from '../components/Catalog/CatalogRp'
  // import CatalogInstantBuy from '../components/Catalog/CatalogInstantBuy'
  import Carts from '../components/Catalog/Carts'
  import ChangeOfferModal from '../components/Catalog/ChangeOfferModal'
  import { FORM_ERROR, FORM_SUCCESS, FORM_UID_CHANGED } from 'store/mutation-types'

  export default {

    components: {
      ErrorNotification,
      CatalogTabs,
      CatalogTab,
      CatalogDom,
      CatalogLld,
      // CatalogRp,
      // CatalogInstantBuy,
      Carts,
      ChangeOfferModal,
    },

    data () {
      return {
        readyToShow: false,
        newoffer: null
      }
    },

    mounted() {
      this.updateFilters({ agencies: this.current_user_agency })
    },

    computed: {

      ...mapState('catalog', {
        catalog_dom: state => state.catalog_dom,
        catalog_lld: state => state.catalog_lld,
        // catalog_pon: state => state.catalog_pon,
        // catalog_inb: state => state.catalog_inb
      }),

      ...mapState('cart', {
        carts: state => state.carts,
        cart: state => state.cart,
        active_cart: state => state.active_cart
      }),

      ...mapState(['agencies']),

      ...mapGetters('catalog', {
        current_user_agency: 'userAgenciesIdList',
        catalog_dom: 'catalog_dom',
        catalog_lld: 'catalog_lld',
        // catalog_pon: 'catalog_pon',
        // catalog_inb: 'catalog_inb',
      }),

      ...mapGetters('cart', {
        carts: 'carts',
        cart: 'cart',
        active_cart: 'active_cart'
      }),

      ...mapGetters(['anyError']),

      ...mapState(['formError']),

      getmyactiveCart () {
        if (this.active_cart.length > 0) {
          return this.active_cart[0]
        }
      },

      // HERE EXTEND THE LOGIC
      getOffersIdFromActiveCart () {
        const data = this.getmyactiveCart
        if (data)
          return data.suborders.map(function (s) {
            return {
              id: s.offer_id,
              suborder_id: s.id,
              distribution_method_id: s.offer.distribution_method_id,
              quantity: s.quantity,
              price: s.price,
              unit: s.unit,
              free_price: s.free_price
            }
          })
        else {
          return []
        }
      },

      readySelectToRender () {
        return (this.agencies.length > 0 && this.current_user_agency)
      },

      getnewoffer () {
        return (this.newoffer)
      },

    },

    methods: {
      ...mapActions('catalog', [
        'updateFilters',
      ]),

      ...mapActions('cart', [
        'initializeCart',
        'fetchCarts',
        'fetchCartById',
        'fetchActiveCart',
        'addOfferToCart',
        'deleteSuborders',
        'updateSubordersQuantity',
        'cleanCart'
      ]),

      addToCart: function (offer) {
        // console.warn("Adding offer into cart " + offer.offer.name)
        this.addOfferToCart({
          cartId: this.getmyactiveCart.id,
          params: {
            offer_id: offer.offer.id,
            quantity: offer.quantity,
            unit: offer.unit,
            price: offer.price,
            free_price: offer.offer.default_price ? 0 : 1,
            //booking_start_date:null,
            //booking_end_date:null
          }
        })
      },

      delSuborderOfCart: function (offer) {
        this.deleteSuborders(offer)
          .then(() => this.initializeCart())
      },

      cleanActiveCart: function (offer) {
        return this.cleanCart(offer)
      },

      getSuborderIdOfOfferId (offerid) {
        const data = this.getOffersIdFromActiveCart

        return data.filter(
          function (item) {
            if (item.id == offerid) {
              return item
            }
          }
        )
      },

      updateSubquantity: function (event) {
        this.updateSubordersQuantity({
          cart_id: this.getmyactiveCart.id,
          suborder_id: this.getSuborderIdOfOfferId(event.suborder_id)[0].suborder_id,
          params: { quantity: event.quantity, _method: "PUT" }
        })
        .then(() => this.initializeCart())
        //this.updateFilters({agencies:this.current_user_agency})
      },

      cartCrusher: function (event) {
        //this.$emit('show-modal', {offer:$event, active_cart:getOffersIdFromActiveCart})
        if (!this.readyToShow) {
          this.readyToShow = !this.readyToShow
          this.newoffer = event
        }
        // Pass the required data here
      },

      confirmModal: function (event) {
        this.cleanActiveCart({ cartId: this.getmyactiveCart.id })
          .then(() => {
            if (event.offer.default_price) {
              this.addToCart({ offer: event.offer, quantity: event.offer.default_price.base_quantity, unit: event.offer.default_price.unit, price: event.offer.default_price.base_price })
            } else {
              if (event.offer.offer.distribution_method_id == 2) {
                  this.addToCart({ offer: event.offer.offer, quantity: event.offer.quantity, unit: "MOS", price: event.offer.price })
              }
              else if (event.offer.offer.distribution_method_id == 1) {
                  this.addToCart({ offer: event.offer.offer, quantity: event.offer.quantity, unit: "MOS", price: event.offer.price })
              }
              else if (event.offer.offer.distribution_method_id == 3) {
                  this.addToCart({ offer: event.offer.offer, quantity: event.offer.quantity, unit: "/PC", price: event.offer.price })
              }
            }
          })
          .then(() => {
            this.readyToShow = false
          })
      }
    },

    created () {
      this.initializeCart()
    },

    beforeCreate(){
        this.$store.commit('FORM_ERROR', {})
    },
  }

</script>

<style>
  .catalog-list,
  .catalog-form {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// client/views/Catalogs.vue